import { Copy } from "@msuite/ui/copy";
import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { formatIban, guardString } from "@msuite/utils/strings";
import type { ContactBankAccountListItem } from "@msuite/utils/types";
import { BankAccountDefaultCell } from "./bank-account-default-cell";
import { BankAccountSourceCell } from "./bank-account-source-cell";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<ContactBankAccountListItem>();

export const columns = [
	columnHelper.accessor("iban", {
		id: "iban",
		header: localized("organization.iban"),
		cell: (cell) => (
			<Copy
				value={cell.getValue()}
				className="font-mono"
			>
				{formatIban(cell.getValue())}
			</Copy>
		),
		size: 280,
	}),
	columnHelper.accessor("bic", {
		id: "bic",
		header: localized("organization.bic"),
		cell: (cell) => (
			<Copy
				value={cell.getValue()}
				className="font-mono"
			>
				{guardString(cell.getValue())}
			</Copy>
		),
		size: 140,
	}),
	columnHelper.accessor("accountHolder", {
		id: "accountHolder",
		header: localized("organization.bank_account_holder"),
		cell: (cell) => guardString(cell.getValue()),
	}),
	columnHelper.accessor("bankName", {
		id: "bankName",
		header: localized("contacts.bank_accounts.bank_name"),
		cell: (cell) => guardString(cell.getValue()),
	}),
	columnHelper.accessor("isDefault", {
		id: "isDefault",
		header: localized("contacts.bank_accounts.is_default"),
		cell: (cell) => <BankAccountDefaultCell isDefault={cell.getValue()} />,
		size: 120,
	}),
	columnHelper.accessor("source", {
		id: "source",
		header: localized("contacts.bank_accounts.source"),
		cell: (cell) => (
			<BankAccountSourceCell
				source={cell.getValue()}
				incomingInvoiceId={cell.row.original.incomingInvoiceId}
			/>
		),
		size: 160,
	}),
	createRowActions(RowActions),
];
